// Lightweight analytics helpers (GA4 + Google Ads). All calls are no-ops if gtag/fbq are undefined.

export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

export const trackPageView = (path) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};

export const trackPhoneClick = () => trackEvent("phone_call_click");

// Fires both the GA4 lead event and the Google Ads conversion.
export const trackLead = () => {
  trackEvent("generate_lead");
  trackEvent("conversion", { send_to: "AW-17711841014/olNaCMOktKAdEPb91P1B" });
};

// Safe Meta Pixel wrapper — no-ops until the pixel is added (see <!-- META PIXEL GOES HERE --> in index.html).
export const fbqSafe = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};
